import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Button } from '@raspberrypifoundation/design-system-react'
import './WhatsNextCard.scss'

const WhatsNextCard = ({ children, description, showPathsButton }) => {
  const { t, i18n } = useTranslation()
  return (
    <div className={'sc-pr-whats-next__container'}>
      <div className={'sc-pr-whats-next__text-container'}>
        <h1 className="sc-pr-whats-next__title">
          {t('project.steps.navigation.whats-next')}
        </h1>

        <div className="sc-pr-whats-next__description">
          <p dangerouslySetInnerHTML={{ __html: description }} />
        </div>
      </div>
      <div className={'sc-pr-whats-next__children'}>{children}</div>
      {showPathsButton && (
        <Button
          className={'sc-pr-whats-next__button'}
          type="secondary"
          text={t('project.project_complete.button.view-all-paths')}
          href={`/${i18n.language}/paths`}
        />
      )}
    </div>
  )
}
WhatsNextCard.propTypes = {
  children: PropTypes.node.isRequired,
  description: PropTypes.string.isRequired,
  showPathsButton: PropTypes.bool,
}

export default WhatsNextCard
